import { t } from '../../../adapters/translate/translate'
import { Container, Content, Point, TeamName } from './styles'

type Props = {
  teamName: string;
  points: number | string;
  color?: string;
  bg?: string;
}

const PointsEllipse = ({ teamName, points, color = '#9F00FF', bg }: Props) => {
  return (
    <Container bg={bg}>
      <Content>
        <Point>{points}</Point>
        <span>{t('Points')}</span>
      </Content>
      <TeamName color={color}>{teamName}</TeamName>
    </Container>
  )
}

export default PointsEllipse
